import { createAsyncThunk } from '@reduxjs/toolkit'

import { getCookie } from '../providers/authentication/authentication.helpers'
import { internalRequest } from '../util/request'

export const updateSellerConfig = createAsyncThunk(
  'update-seller-config',
  async ({ values, userId }: { values: Record<string, any>; userId: number }, { rejectWithValue, dispatch }) => {
    const token = getCookie('token')

    try {
      const { data } = await internalRequest({
        headers: {
          authorization: token,
        },
        url: `/seller/config`,
        method: 'PUT',
        data: { values, userId },
        dispatch,
      })

      return data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)
